import React from 'react';
import {
  HelperText,
  StyledIcon,
  VisualPickerButtonWrapper,
  SizeVariant,
} from './VisualPickerButton.styles';
import { MarginProps } from '../../../theme/styledProps';
import { Box } from '../Box/Box';

export interface VisualPickerButtonProps
  extends React.ComponentPropsWithoutRef<'button'>,
    MarginProps {
  helperText?: string;
  icon?: string;
  rightText?: React.ReactNode;
  rightHelperText?: string;
  sizeVariant?: SizeVariant;
}

export const VisualPickerButton: React.FC<VisualPickerButtonProps> = ({
  helperText,
  icon,
  rightText,
  rightHelperText,
  children,
  sizeVariant = 'medium',
  ...rest
}) => {
  return (
    <VisualPickerButtonWrapper type="button" sizeVariant={sizeVariant} {...rest}>
      {icon && <StyledIcon className={icon} />}

      <Box as="span" display="flex" flexDirection="column" flex={1}>
        {children}

        {helperText && <HelperText>{helperText}</HelperText>}
      </Box>

      {rightText && (
        <Box as="span" display="flex" flexDirection="column" alignItems="flex-end" ml="16">
          {rightText}

          {rightHelperText && <HelperText>{rightHelperText}</HelperText>}
        </Box>
      )}
    </VisualPickerButtonWrapper>
  );
};
